<template>
  <div class="transferBox">
    <img :src="loadingImg" alt="">
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        innerWidth:'',
        loadingImg: require('./image/loading.gif')
      }
    },
    computed:{
    },
    methods:{
      viewFillData: function () {
        this.innerWidth = window.innerWidth;
        setTimeout(() => {
          if (this.innerWidth <= 800){
            this.$router.replace({name:'AppHomePage'});
          } else {
            this.$router.replace({name:'ComputerHomePage'});
          }
        }, 500)
      }
    },
    mounted:function(){
      this.viewFillData();
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  .transferBox{
    width:100%;
    height:100%;
    img{
      width:100%;
      position: absolute;
      top:0;left:0;
    }
  }
</style>
